














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class KualitasNyeri extends Vue {
  @Prop() setKualitasNyeri: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  // kualitas = null;

  // @Watch("kualitas")
  // changeKualitas(val) {
  //   this.$emit("kualitasNyeri", val);
  // }

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setKualitasNyeri == "" || this.setKualitasNyeri == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setKualitasNyeri")
  valKualitas(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("kualitasNyeri", val);
    this.setKualitasNyeri = val;
  }
}
